// extracted by mini-css-extract-plugin
export default {"chipsContainer":"FormChips_chipsContainer__Z-drS"};